const fixedTags = {
  restaurant: "2sn6dbecc3",
  onedaytrip: "k0bb01mkds",
  ticket: "80ulgbfn21",
  shopping: "chzlh8hklq"
}

export function hasFixedTag(thing, tag) {
  return thing.tags[fixedTags[tag]]
}

export function isRestaurant(thing) {
  return hasFixedTag(thing, "restaurant")
}

export function isShopping(thing) {
  return hasFixedTag(thing, "shopping")
}

export default fixedTags
